import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";
import React, { Fragment, useState } from "react";

import ErrorBoundary from "../Error";
import Header from "../Header";
import Navigation from "../Navigation";
import Routes from "./Routes";
import styles from "./styles";

const App: React.FunctionComponent<WithStyles<typeof styles> & {
  toggleDarkMode: (darkMode: boolean) => void;
}> = ({ classes, toggleDarkMode }) => {
  const [drawerState, toggleDrawer] = useState(false);

  return (
    <Fragment>
      <div className={classes.root}>
        <Header
          id="app-header"
          classes={classes}
          open={drawerState}
          handleOpen={() => toggleDrawer(!drawerState)}
          toggleDarkMode={toggleDarkMode}
        />
        <Navigation
          classes={classes}
          open={drawerState}
          handleClose={() => toggleDrawer(false)}
        />
        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          <div className={classes.page}>
            <ErrorBoundary>
              <Routes />
            </ErrorBoundary>
          </div>
        </main>
      </div>
    </Fragment>
  );
};

export default withStyles(styles)(App);
